export type PageItem = number | "ellipsis";

export interface VisiblePagesOptions {
  /** Pages on each side of current (excluding first/last). */
  siblingCount?: number;
  /** If total pages ≤ this, show every page number. */
  maxAll?: number;
}

/**
 * Compact page list: e.g. 1 … 5 6 7 … 27 instead of 1..27.
 */
export function getVisiblePages(
  current: number,
  total: number,
  options: VisiblePagesOptions = {}
): PageItem[] {
  const siblingCount = options.siblingCount ?? 1;
  const maxAll = options.maxAll ?? 9;
  if (total <= 0) return [];
  if (total <= maxAll) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const items: PageItem[] = [1];
  const start = Math.max(2, current - siblingCount);
  const end = Math.min(total - 1, current + siblingCount);
  if (start > 2) items.push("ellipsis");
  for (let i = start; i <= end; i++) items.push(i);
  if (end < total - 1) items.push("ellipsis");
  if (total > 1) items.push(total);
  return items;
}
